import { useMutation, UseMutationOptions } from 'react-query'

import { fetchAndReturnRaw } from 'data/utils/utils'

import { useToast } from 'ui/components/Toast'

import { invalidateAutomationConnections } from './useAutomationConnections'

export type AutomationConnectionDeleteRequest = {
    automationConnectionSid: string
}

export function useDeleteAutomationConnection(
    options: UseMutationOptions<unknown, unknown, AutomationConnectionDeleteRequest> = {}
) {
    const toast = useToast()

    return useMutation(
        async ({ automationConnectionSid }: AutomationConnectionDeleteRequest) => {
            return fetchAndReturnRaw(`automations/connections/${automationConnectionSid}/`, {
                method: 'DELETE',
            })
        },
        {
            ...options,
            onError: async (error: any) => {
                console.warn('Deleting automation connection failed', { error })
                toast({
                    title: 'There was a problem deleting the connection. Please try again later.',
                    type: 'error',
                })
            },
            onSettled: async () => {
                await invalidateAutomationConnections()
            },
        }
    )
}
